require('./bootstrap');

import $ from 'jquery';
import * as bootstrap from 'bootstrap-5';
import 'select2';

window.$ = window.jQuery = $;

require('bootstrap-validator');
require('jquery.dirty');
require('owl.carousel');
window.datetimepicker = require('bootstrap4-datetimepicker');
window.WorkerTimer = require("worker-timer");
// window.ClassicEditor = require("@ckeditor/ckeditor5-build-classic");
// window.SpecialCharacters from '@ckeditor/ckeditor5-special-characters';

// window.http = require('http')
// var Cookies = require('cookies');

import Alpine from 'alpinejs';
import swal from 'sweetalert';
import moment from 'moment';
import 'moment-timezone';
import Dropzone from "dropzone";

window.Alpine = Alpine;
window.moment = moment;
window.Modal = bootstrap.Modal;

Alpine.start();

// import './actions.js';
